import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Label = ({ className, children, required }) => (
  <StyledLabel className={className}>
    {children}
    {required ? <span className="danger">{' *'}</span> : ''}
  </StyledLabel>
);

Label.propTypes = {
  required: PropTypes.bool,
};

Label.defaultProps = {
  required: false,
};

const StyledLabel = styled.label`
  color: ${props => props.theme.subText};
  cursor: pointer;
  display: block;
  font-size: ${props => props.theme.formFontSize};
  font-weight: 300;
  line-height: ${props => props.theme.formLineHeight};
  width: 100%;
  .required {
    color: ${props => props.theme.subText};
  }
  .danger {
    color: ${props => props.theme.danger};
  }
`;

export default Label;
